import Api from '@/apis/productContentApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getOverview () {
    return Api()
      .get('/productContent')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.ProductContent.Messages.GetProductContentErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async getDetails (nodeId) {
    return Api()
      .get('/productContent/' + nodeId)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.ProductContent.Messages.GetProductDetailsErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
